module.exports = __webpack_public_path__ + "img/9788992684224.88deb566.jpg";